import panic from 'errors/panic';
import { RevisionActionProps } from 'components/tables/data/revision/types';
import { useApi } from 'api/api-context';
import { useNavigate } from 'react-router-dom';
import openBrainItUrl from 'utils/open-brain-it-url';

type RevisionActionPropsExtended = RevisionActionProps & { deadline: string };

/**
 * Implements the sign action for revision.
 */
export default function useSignAction() {
  const { getAction } = useApi();
  const navigate = useNavigate();

  /**
   * Makes a call to the API to initiate the signing of the revision.
   */
  async function signRevision({ revision: { revisionId, kind }, deadline }: RevisionActionPropsExtended) {
    const revisionSignMultipleDocsAction = getAction('RevisionSignMultipleDocs');

    try {
      const { redirectUrl } = await revisionSignMultipleDocsAction({
        payload: {
          revisionIds: [revisionId],
          documentValidUntil: deadline,
        },
      });

      openBrainItUrl(redirectUrl, navigate);
    } catch (e: any) {
      panic(e);
    }
  }

  return {
    signRevision,
  };
}
